import { useEffect, useState } from 'react';
import { contato, linkWhatsApp } from '../data/conteudo';
import { IconeFechar, IconeMenu, IconeWhatsApp } from './Icones';
import styles from './Cabecalho.module.css';

const links = [
  { href: '#sobre', rotulo: 'Sobre mim' },
  { href: '#especialidades', rotulo: 'Especialidades' },
  { href: '#como-funciona', rotulo: 'Como funciona' },
  { href: '#duvidas', rotulo: 'Dúvidas' },
  { href: '#contato', rotulo: 'Contato' },
];

const Cabecalho = () => {
  const [menuAberto, setMenuAberto] = useState(false);
  const [rolou, setRolou] = useState(false);

  useEffect(() => {
    const aoRolar = () => setRolou(window.scrollY > 8);
    aoRolar();
    window.addEventListener('scroll', aoRolar, { passive: true });
    return () => window.removeEventListener('scroll', aoRolar);
  }, []);

  useEffect(() => {
    if (!menuAberto) return;
    const aoTeclar = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuAberto(false);
    };
    window.addEventListener('keydown', aoTeclar);
    return () => window.removeEventListener('keydown', aoTeclar);
  }, [menuAberto]);

  const fecharMenu = () => setMenuAberto(false);

  return (
    <header className={`${styles.cabecalho} ${rolou || menuAberto ? styles.comBorda : ''}`}>
      <div className={`container ${styles.barra}`}>
        <a href="#inicio" className={styles.marca} onClick={fecharMenu}>
          <span className={styles.psi} aria-hidden="true">Ψ</span>
          <span className={styles.nome}>
            {contato.nome}
            <small>{contato.titulo}</small>
          </span>
        </a>

        <button
          type="button"
          className={styles.botaoMenu}
          aria-expanded={menuAberto}
          aria-controls="menu-principal"
          onClick={() => setMenuAberto((aberto) => !aberto)}
        >
          {menuAberto ? <IconeFechar /> : <IconeMenu />}
          <span className="sr-only">{menuAberto ? 'Fechar menu' : 'Abrir menu'}</span>
        </button>

        <nav
          id="menu-principal"
          className={`${styles.menu} ${menuAberto ? styles.menuAberto : ''}`}
          aria-label="Navegação principal"
        >
          <ul>
            {links.map((link) => (
              <li key={link.href}>
                <a href={link.href} onClick={fecharMenu}>
                  {link.rotulo}
                </a>
              </li>
            ))}
          </ul>
          <a
            className={`botao botao-principal ${styles.agendar}`}
            href={linkWhatsApp}
            target="_blank"
            rel="noopener noreferrer"
            onClick={fecharMenu}
          >
            <IconeWhatsApp />
            Agendar consulta
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Cabecalho;
